module.exports = __webpack_public_path__ + "img/tech_obs.d57e9b43.svg";